import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/logo-board/logo-board-v1.module.css';
import v2 from '@/components/landing-page/components/logo-board/logo-board-v2.module.css';

const paths: Record<string, string> = import.meta.glob('./assets/*', {
  eager: true,
  query: '?url',
  import: 'default',
});

const LogoBoard = () => (
  <div className={cn(v1.LogoBoard, v2.LogoBoard)}>
    <div className={cn(v1.Wrapper, v2.Wrapper)}>
      {Object.values(paths).map((file, i) => (
        <div key={file} className={cn(v1.Item, v2.Item)}>
          <img data-testid='logo-board-image' src={file} alt={file} className={cn(v1.Image, v2.Image)} />
        </div>
      ))}
    </div>
  </div>
);

export default LogoBoard;
